var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.475195,
    y: 1.20371,
    width: 65.45,
    height: 65.45,
    rx: 32.725,
    fill: "#1397F5",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.475195,
    y: 1.20371,
    width: 65.45,
    height: 65.45,
    rx: 32.725,
    stroke: "#E6E6E6",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6316_2947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8008 18.5283H17.8008V50.5283H49.8008V18.5283Z",
    fill: "url(#paint0_linear_6316_2947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0558 39.3344V50.5282H35.7617V39.3344H39.4872L40.2715 34.8176H35.9578V31.8718C35.9578 30.6935 36.546 29.5152 38.5068 29.5152H40.4676V25.5876C40.4676 25.5876 38.7029 25.1948 36.9382 25.1948C33.4088 25.1948 31.0558 27.355 31.0558 31.2827V34.8176H27.1343V39.3344H31.0558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6316_2947",
    x1: 33.8008,
    y1: 18.5283,
    x2: 33.8008,
    y2: 50.5283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0563DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6316_2947"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.8008,
    y: 18.5283,
    width: 32,
    height: 32,
    rx: 8.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookShare);
export default __webpack_public_path__ + "static/media/facebook_share.3e3ce9bd23b255ed07fee09cc90b8b2c.svg";
export { ForwardRef as ReactComponent };